import React from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center', // по вертикали
  },

  tableText: {
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})

const PairWeightTournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  biggestFish,
  isFinish,
  countFish,
  minWeight,
}) => {
  function formatWeight(weight) {
    return weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
  return (
    <Document style={{ margin: 0 }} scale={0.9}>
      <Page
        size="A4"
        style={{
          paddingBottom: 30,
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 20,
          fontFamily: 'Roboto',
        }}
      >
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>

        <Text
          style={{
            fontSize: 12,

            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          {isFinish
            ? countFish === 1
              ? ' ПРОТОКОЛ ПО САМОЙ КРУПНОЙ РЫБЕ'
              : ` ПРОТОКОЛ ПО ${countFish} КРУПНЫМ РЫБАМ  `
            : countFish === 1
              ? 'ИНФОРМАЦИОННЫЙ ПРОТОКОЛ ПО САМОЙ КРУПНОЙ РЫБЕ'
              : `ИНФОРМАЦИОННЫЙ ПРОТОКОЛ ПО ${countFish} КРУПНЫМ РЫБАМ  `}
        </Text>

        {/* Таблица результатов */}
        <View>
          <View
            style={{
              width: '100%',
              borderStyle: 'solid',
              borderWidth: 0.3,
              borderColor: '#000',
            }}
          >
            <View
              style={{
                height: '20px',
                flexDirection: 'row',
                alignItems: 'stretch', // важно!
              }}
            >
              {countFish > 1 ? (
                <View style={[styles.tableColHeader, { width: '47%' }]}>
                  <Text style={[styles.tableText, { textAlign: 'left' }]}>
                    {' '}
                    Команда
                  </Text>
                </View>
              ) : (
                <View style={[styles.tableColHeader, { width: '72%' }]}>
                  <Text style={[styles.tableText, { textAlign: 'left' }]}>
                    {' '}
                    Команда
                  </Text>
                </View>
              )}
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>Сектор</Text>
              </View>

              {/* <Text style={[styles.tableColHeader, { width: '12%' }]}>
                Кол-во
              </Text> */}

              <View style={[styles.tableColHeader, { width: '10%' }]}>
                <Text style={styles.tableText}>Вес</Text>
              </View>

              {countFish > 1 && (
                <View style={[styles.tableColHeader, { width: '25%' }]}>
                  <Text style={styles.tableText}> Список рыб (вес)</Text>
                </View>
              )}
              <View style={[styles.tableColHeader, { width: '10%' }]}>
                <Text style={styles.tableText}>Место</Text>
              </View>
            </View>
          </View>

          {data.map((item, index) => (
            <View key={index} wrap={false}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'stretch', // важно для одинаковой высоты 8FBC8F
                  backgroundColor:
                    item.overallRank < 4
                      ? '#fff'
                      : item.totalWeight === 0
                        ? '#fff'
                        : '#fff',
                }}
              >
                {countFish > 1 ? (
                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '47%', alignItems: 'flex-start' },
                    ]}
                  >
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      <Text style={{ fontWeight: 'bold' }}>
                        {item.teamName}
                      </Text>
                      {'\n'}
                      {item.sp}
                    </Text>
                  </View>
                ) : (
                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '72%', alignItems: 'flex-start' },
                    ]}
                  >
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      <Text style={{ fontWeight: 'bold' }}>
                        {item.teamName}
                      </Text>
                      {'\n'}
                      {item.sp}
                    </Text>
                  </View>
                )}
                <View style={[styles.tableColHeader, { width: '8%' }]}>
                  <Text style={styles.tableText}>{item.sector}</Text>
                </View>

                {/* <Text
                  style={{ width: '12%', fontSize: 8, textAlign: 'center' }}
                >
                  {item.validFishCount}
                </Text> */}

                <View style={[styles.tableColHeader, { width: '10%' }]}>
                  <Text style={styles.tableText}>
                    {formatWeight(item.topFishWeight)}
                  </Text>
                </View>

                {countFish > 1 && (
                  <View style={[styles.tableColHeader, { width: '25%' }]}>
                    <Text style={styles.tableText}>
                      {item.fishesString || '-'}
                    </Text>
                  </View>
                )}

                <View style={[styles.tableColHeader, { width: '10%' }]}>
                  <Text style={styles.tableText}>
                    {item.overallRank % 1 === 0
                      ? item.overallRank
                      : item.overallRank.toFixed(1)}
                  </Text>
                </View>
              </View>
              {/* {item.isTie && (
                <Text style={styles.tieNote}>
                  * Деление мест с командой {item.tieWith}
                </Text>
              )} */}
            </View>
          ))}
        </View>

        {/* Итоговые значения */}
        {/* <View style={{ marginTop: 10 }}>
          <Text style={{ fontSize: 8 }}>
            Всего зачётной рыбы (≥{minWeight} г): {totalFishCount} шт. / Общий
            вес топ {countFish} рыб: {totalWeight} г
          </Text>
          <Text style={{ fontSize: 8 }}>
            Самая крупная рыба: {biggestFish.weight} г (Команда:{' '}
            {biggestFish.pair})
          </Text>
        </View> */}

        {/* Подписи */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 30,
          }}
        >
          {administrator.map((admin, i) => (
            <View
              key={i}
              style={{
                width: '45%',
                borderTop: '1px solid #000',
                paddingTop: 2,
              }}
            >
              <Text style={{ fontSize: 8, textAlign: 'center' }}>
                {admin.surname} {admin.name} {admin.patronymic} ({admin.role},{' '}
                {admin.rank})
              </Text>
            </View>
          ))}
        </View>

        {/* Логотипы спонсоров */}
        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default PairWeightTournamentProtocolPDF
